import React from 'react'
import HomeLeft from '../home/home_left/HomeLeft'
import VideoListRight from './VideoListRight'
export default function VideoList() {
  return (
    <div className='row' >
                <HomeLeft></HomeLeft>
                <VideoListRight/>
            </div>
  )
}
